module.exports = __webpack_public_path__ + "static/icon-pdd-01-747999f92c0425639afbefb7030df3cc.svg";